<script>
const i18nKey = 'WORKSCHEDULES'

export default {
    data() {
        return {
            plannedTypes: [
                {
                    text: this.plannedTypeToText('1'),
                    value: true, // Assuming '1' represents 'Yes'
                },
                {
                    text: this.plannedTypeToText('0'),
                    value: false, // Assuming '0' represents 'No'
                },
            ],
        }
    },

    methods: {
        plannedTypeToText(value) {
            return this.getI18n(i18nKey, `PLANNED_TYPES.${value}`)
        },
    },
}
</script>
